import { Component, Input, OnInit } from '@angular/core';
import { MatLegacyRadioChange as MatRadioChange } from '@angular/material/legacy-radio';
import { throwToolbarMixedModesError } from '@angular/material/toolbar';
import { Question, Response } from 'src/app/models/user-interests';

@Component({
  selector: 'app-radio-question-level',
  templateUrl: './radio-question-level.component.html',
  styleUrls: ['./radio-question-level.component.scss'],
})
export class RadioQuestionLevelComponent implements OnInit {
  availableResponsesCurrentLevel: Response[];
  userResponsesCurrentLevel: string[];
  hasNextLevel: boolean;
  radioGroupName: string;

  @Input()
  question: Question;

  @Input()
  level: number;

  @Input()
  responses: Response[];

  constructor() {}

  ngOnInit() {
    this.availableResponsesCurrentLevel = this.question.getAvailableResponsesForLevel(this.level);
    this.userResponsesCurrentLevel = this.question.getUserResponsesForLevel(this.level)
      ? this.question.getUserResponsesForLevel(this.level)
      : [];
    this.radioGroupName = this.question.id + '-' + this.level;
  }

  onSelected(event: MatRadioChange) {
    this.question.provideResponseForLevel(this.level, event.value);
    this.userResponsesCurrentLevel = this.question.getUserResponsesForLevel(this.level);
  }
}
